import React, {useEffect, useRef} from 'react';
import { isAuthenticated } from '../../auth';
import { Fragment } from 'react'
import { ChatAltIcon, TagIcon, UserCircleIcon } from '@heroicons/react/solid'

const ChatArea = ({messages, trade}) => {
    const  {user: {_id, name}, token } = isAuthenticated();
    const chatRef = useRef(null);
    useEffect(() => {
        chatRef.current.scrollIntoView();
    },[messages]);

    const ProfilePicture = ({message}) => ( //confusing logic, I know. Sorry
        <>
            <div className='relative'>
                { trade.reciever === _id ?
                    <>
                        { message.userName === name ?
                        <img
                            className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white"
                            src={trade.recieverProfilePicture}
                            alt=""
                        />
                            :
                        <img
                            className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white"
                            src={trade.senderProfilePicture}
                            alt=""
                        />
                        }
                    </>
                    :
                    <>
                        { message.userName === name ?
                        <img
                            className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white"
                            src={trade.senderProfilePicture}
                            alt=""
                        />
                            :
                        <img
                            className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white"
                            src={trade.recieverProfilePicture}
                            alt=""
                        />
                        }
                    </>
                }
            </div>
        </>
    );

    return (
        <div className="flow-root overflow-y-scroll h-[32rem] flex flex-col-reverse border-2 p-3 mb-4 rounded-lg" >
            <ul className="-mb-8 relative">
                {messages.map((message, i) => (
                    <li key={i} className='justify-end'>
                        <div className="relative pb-8">
                            {i !== messages.length - 1 ? (
                                <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" />
                            ) : null}
                            <div className="relative flex items-start space-x-3">
                                <>
                                    <div className="relative">
                                        <ProfilePicture message={message}/>
                                    </div>
                                    <div className="min-w-0 flex-1">
                                        <div>
                                            <div className="text-sm">
                                                <p className="font-medium text-gray-900">
                                                    {message.userName}
                                                </p>
                                            </div>
                                            <p className="mt-0.5 text-sm text-gray-500">date</p>
                                        </div>
                                        <div className="mt-2 text-sm text-gray-700">
                                            <p>{message.message}</p>
                                        </div>
                                    </div>
                                </>
                            </div>
                        </div>
                    </li>
                ))}
                <div ref={chatRef} id='chat'> </div>
            </ul>
        </div>
    )
};

export default ChatArea;
